<header class="card-head">
  <h2 class="card-title">{{ title() }}</h2>
  @if (source(); as s) {
    <app-charter-provenance [from]="s" variant="source" [current]="true" />
  }
</header>

<app-charter-signing-guide
  [governance]="governance()"
  [clauses]="clauses()"
  [isCorporation]="isCorporation()"
  [currency]="currency()" />

@if (bodies().length === 0) {
  <p class="empty">Os atos lidos não nomeiam administradores.</p>
}

@for (group of bodies(); track group.body) {
  <h3 class="body-title">
    {{ bodies().length > 1 || isCorporation() ? group.label : 'Administradores' }}
    @if ($first && !isCorporation() && model(); as m) {
      <span class="body-title__model">· {{ m }}</span>
    }
  </h3>
  <ul class="people">
    @for (admin of group.administrators; track admin.administratorId) {
      <li>
        <app-charter-administrator-item
          [admin]="admin"
          [isCorporation]="isCorporation()"
          [base]="source()" />
      </li>
    }
  </ul>
}
